import React from "react";
import { useLocation } from "react-router-dom";
import { Section, Button } from "@vild/site-ui";

function buildAppUrl(args: { kind: "sign-in" | "sign-up"; search: string }): string {
  const base = "https://vild.ai";
  const path = args.kind === "sign-in" ? "/app/sign-in" : "/app/sign-up";
  return `${base}${path}${args.search || ""}`;
}

export function RedirectToAppAuth({ kind }: { kind: "sign-in" | "sign-up" }) {
  const location = useLocation();

  const target = React.useMemo(() => buildAppUrl({ kind, search: location.search }), [kind, location.search]);

  React.useEffect(() => {
    window.location.href = target;
  }, [target]);

  return (
    <Section className="text-center py-40">
      <h1 className="text-2xl font-bold mb-4">Opening Vild…</h1>
      <p className="text-zinc-500 mb-8">You’re being redirected to the app.</p>
      <Button asLink={target} variant="primary">
        Continue
      </Button>
    </Section>
  );
}

